import React, { useContext, useMemo, useState } from 'react'
import { Button, Col, Row, useToaster } from 'react-angle-dashboard-components'
import InputMask from 'react-input-mask'
import { useHistory } from 'react-router-dom'
import { Question, QuestionContainer, SubText } from '../../components/Question'
import useStep from '../../hooks/use-step'
import { Paths } from '../../routes/paths'
import { GbsStore } from '../../store'
import { useInitialQuoteInformation } from '../../store/selectors'
import { groupService } from '../../services'
import { Actions } from '../../store/actions'

const stepKey = 'employeesAmount'

export const EmployeesAmount = () => {
  const history = useHistory()
  const { dispatch } = useContext(GbsStore)
  const { show } = useToaster()

  const initialQuoteInformation = useInitialQuoteInformation()
  const [value, setValue] = useState<number | null>(() => {
    const numberOfEmployees = initialQuoteInformation?.numberOfEmployees

    return numberOfEmployees ? parseInt(numberOfEmployees.toString()) : null
  })

  const [isLoading, setIsLoading] = useState(false)

  const isDisabled = !value || isLoading

  const onContinue = async () => {
    setIsLoading(true)
    if ((value as number) < 2) {
      show({
        message: 'Number of employees must be greater than 2',
        icon: '',
        type: 'danger'
      })
      return setIsLoading(false)
    }

    if ((value as number) > 50) {
      window.location.assign('https://anglehealth.com/self-serve/over-50')
    }

    if ((value as number) < 2) {
      show({
        message: 'Minimum of 2 employees required',
        icon: '',
        type: 'danger'
      })
      return setIsLoading(false)
    }

    try {
      await groupService.modifyGroup({
        total_individuals: value
      })

      dispatch({
        type: Actions.SetInitialQuoteInformation,
        payload: { numberOfEmployees: value || 0 }
      })

      setIsLoading(false)
      history.push(Paths.haveBroker)
    } catch (e) {
      show({
        message: 'Something went wrong',
        icon: 'icon-cancel',
        type: 'danger'
      })
    }
  }

  const stepConfig = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 10
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [])

  useStep(stepKey, stepConfig, dispatch)
  return (
    <QuestionContainer>
      <Row>
        <Col xs={12}>
          <Question
            type="text"
            defaultValue={value}
            text="How many employees do you have?"
            placeholder="#"
            onChange={(value) => setValue(Number(value))}
            styles={{
              maxWidth: '90px'
            }}
            as={InputMask}
            mask="9999"
            maskChar={''}
          ></Question>
        </Col>
      </Row>

      <div className="text-center">
        <p
          style={{ marginTop: -30, marginBottom: 30 }}
          className="text-secondary"
        >
          Please enter all your full-time (30 or more hours per week) employees
        </p>
        <Button
          style={{ width: 130 }}
          variant="primary"
          onClick={onContinue}
          disabled={isDisabled}
        >
          Next
        </Button>
      </div>

      <SubText>
        All insurance plans are issued by Angle Insurance Company of Utah
      </SubText>
    </QuestionContainer>
  )
}

export default EmployeesAmount
